 /*
 * Copyright (C) 2020 to Present Applause App Quality, Inc. All rights reserved.
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ErrorDirective } from './error.directive';
import { FormFieldComponent } from './form-field.component';
import { HintDirective } from './hint.directive';
import { IsFormFieldRequiredPipe } from './is-form-field-required.pipe';
import { LabelErrorDirective } from './label-error.directive';
import { LabelPlaceholderDirective } from './label-placeholder.directive';
import { ContainerErrorsComponent } from './container-errors/container-errors.component';
import { LabelIconDirective } from './label-icon.directive';
import { FieldActionDirective } from './ngf-field-action.directive';
import { FormFieldLabelComponent } from './form-field-label/form-field-label.component';
import { MatIconModule } from '@angular/material/icon';
import { NgfTooltipDirective } from '@ng-falcon/ngf-tooltip/ngf-tooltip.directive';

@NgModule({
  imports: [
    CommonModule,
    MatIconModule,
    NgfTooltipDirective
  ],
  declarations: [
    FormFieldComponent,
    ErrorDirective,
    FieldActionDirective,
    HintDirective,
    LabelErrorDirective,
    LabelIconDirective,
    LabelPlaceholderDirective,
    ContainerErrorsComponent,
    FormFieldLabelComponent,
    IsFormFieldRequiredPipe,
  ],
  exports: [
    FormFieldComponent,
    ErrorDirective,
    FieldActionDirective,
    HintDirective,
    LabelIconDirective,
    LabelErrorDirective,
    LabelPlaceholderDirective,
    LabelIconDirective,
    ContainerErrorsComponent,
    FormFieldLabelComponent,
    IsFormFieldRequiredPipe,
  ]
})
export class FormFieldModule {}
